import { render, staticRenderFns } from "./TradeFlexListing.vue?vue&type=template&id=3a68cc4c&scoped=true&"
import script from "./TradeFlexListing.vue?vue&type=script&lang=js&"
export * from "./TradeFlexListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a68cc4c",
  null
  
)

export default component.exports